import { render } from "./Dusun.vue?vue&type=template&id=67d8f36f"
import script from "./Dusun.vue?vue&type=script&lang=js"
export * from "./Dusun.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__